import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiClientService } from './../../shared/services/api-client.service';
import { AB_API_QRCODE } from './../../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class QrCodeService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_QRCODE);
  }

  getQrCode(): Observable<any> {
    return this.get();
  }
}
